/** Strings owned by the adb-proxy area. */
export const ADB_PROXY_STRINGS = {
    // Farm-list page
    'adbproxy.title': { en: 'Remote ADB', ru: 'Удалённый ADB' },
    'adbproxy.ip_whitelist': { en: 'IP whitelist', ru: 'Whitelist IP' },
    'adbproxy.page_hint': {
        en: 'Enable a device to open a dedicated TCP port on the panel host. Operators then run {command}. Access is restricted to the global IP whitelist — an empty whitelist blocks everyone.',
        ru: 'Включите устройство, чтобы открыть выделенный TCP-порт на хосте панели. Оператор затем выполняет {command}. Доступ ограничен глобальным whitelist IP — пустой список блокирует всех.',
    },
    'adbproxy.no_farms': { en: 'No farms configured', ru: 'Нет настроенных ферм' },
    // Device-list page
    'adbproxy.back_farms': { en: '← Farms', ru: '← Фермы' },
    'adbproxy.farm_not_found': { en: 'Farm not found.', ru: 'Ферма не найдена.' },
    'adbproxy.not_available_for_farm': { en: 'Remote ADB is not available for this farm type.', ru: 'Удалённый ADB недоступен для этого типа фермы.' },
    'adbproxy.no_live_devices': { en: 'No live devices in this farm.', ru: 'В этой ферме нет активных устройств.' },
    'adbproxy.enable': { en: 'Enable', ru: 'Включить' },
    'adbproxy.disable': { en: 'Disable', ru: 'Отключить' },
    'adbproxy.request_failed': { en: 'Request failed', ru: 'Запрос не выполнен' },
    'adbproxy.network_error': { en: 'Network error', ru: 'Ошибка сети' },
    // IP whitelist modal
    'adbproxy.whitelist_title': { en: 'ADB IP whitelist', ru: 'Whitelist IP для ADB' },
    'adbproxy.whitelist_hint': {
        en: 'Only these source IPs may connect to any remote-ADB port. An empty list blocks everyone.',
        ru: 'Подключаться к любому порту удалённого ADB могут только эти IP. Пустой список блокирует всех.',
    },
    'adbproxy.add_ip': { en: 'Add IP', ru: 'Добавить IP' },
    'adbproxy.ip_placeholder': { en: 'e.g. 203.0.113.7', ru: 'например, 203.0.113.7' },
    'adbproxy.whitelist_empty': { en: 'Empty — all connections are denied.', ru: 'Пусто — все подключения запрещены.' },
    'adbproxy.invalid_ip': { en: 'Invalid IP: {ip}', ru: 'Некорректный IP: {ip}' },
};
